module.exports = __webpack_public_path__ + "static/media/footer-mail-web.115dbc55.svg";